export const ID = 'a384c1bd-f30a-447d-a64a-3e19efdd4689';

export const NAME = 'Storage Mart Search/Geo-Location';
